import ReactTooltip from "react-tooltip"

export default ReactTooltip
